import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPersonOfficer = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "2.5em",
	height: "2.5em",
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M20 27V31",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.8 21.907L10.975 25.417C10.6781 25.5942 10.4322 25.8453 10.2613 26.1459C10.0905 26.4465 10.0004 26.7862 10 27.132V31H30V27.132C30 26.7866 29.9106 26.4471 29.7404 26.1466C29.5702 25.846 29.3252 25.5947 29.029 25.417L23.2 21.907",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26 13.544V15C26 20 23.314 23 20 23C16.686 23 14 20 14 15V13.544",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20 15C23.866 15 27 13.6569 27 12C27 10.3431 23.866 9 20 9C16.134 9 13 10.3431 13 12C13 13.6569 16.134 15 20 15Z",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20 13C20.5523 13 21 12.5523 21 12C21 11.4477 20.5523 11 20 11C19.4477 11 19 11.4477 19 12C19 12.5523 19.4477 13 20 13Z",
			fill: "currentColor"
		})
	]
});
const ForwardRef = forwardRef(SvgPersonOfficer);
export default ForwardRef;
